import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
import { IFSC } from './getAllBanks'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const getCityBody = (bankName: string) => {
  return {
    bankName: bankName,
    bankCity: '',
    bankBranch: '',
    source: IFSC,
  }
}

export const getAllCities = (tokens: any, bankName: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: APIEndPoints.getIfscCode,
    method: 'POST',
    config: config,
    body: getCityBody(bankName),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
